<template>
  <div class="pa-4 custom-list">
    <v-row class="ma-0">
      <v-col cols="12">
        <div
          @click="panel = !panel"
          class="primary white--text px-6 py-3"
          :class="panel ? 'rounded-t-lg' : 'rounded-lg'"
        >
          <v-row>
            <v-col cols="6">
              <div>
                <span v-if="Object.keys(selectedReport).length !== 0">
                  Selected Report : {{ selectedReport.text }}
                </span>
                <span v-else> Select Report Type </span>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <v-icon color="white" :class="panel ? `${rotatedIcon}` : ''">
                mdi-chevron-down
              </v-icon>
            </v-col>
          </v-row>
        </div>
        <v-expand-transition>
          <div
            v-if="panel"
            class="grey lighten-2 pa-3 rounded-b-lg"
            style="overflow-x: scroll"
          >
            <div class="report-grid">
              <v-card
                v-for="(item, i) in reportTypes"
                :key="i"
                :class="
                  selectedReport.text == item.text
                    ? 'on-hover float-left ma-2 pa-4 text-center primary white--text font-weight-bold'
                    : 'on-hover float-left ma-2 pa-4 text-center text_color--text'
                "
                class="card-height rounded-lg"
                outlined
                tile
                @click="updateReportType(item)"
              >
                <v-row class="py-2" no-gutters>
                  <v-col cols="12" class="d-flex justify-center">
                    <v-icon
                      class="pb-2"
                      :color="
                        selectedReport.text == item.text ? 'white' : 'primary'
                      "
                      >{{ item.icon }}</v-icon
                    >
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center">
                    <span class="text-caption"> {{ item.text }}</span>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
        </v-expand-transition>
        <v-alert
          border="left"
          colored-border
          color="red"
          v-if="distinctErrors.length"
        >
          <v-list class="py-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="text-grey font-weight-medium"
                >Error(s):
              </v-list-item-title>
              <v-list-item-subtitle
                class="pl-4 pt-1 text-grey"
                v-for="(err, index) in distinctErrors"
                :key="index"
              >
                {{ err }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list>
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-form v-model="isValid">
          <v-card elevation="0" class="pa-4 rounded-lg">
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters class="px-2">
                  <v-col cols="12 pb-3">
                    <span class="text-body-1 font-weight-bold">Filters</span>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col>
                        <DatePicker
                          v-model="reportFilters.start_date"
                          type="date"
                          :allowed-dates="startDateValidation"
                          label="start date *"
                          :rules="[(val) => !!val || 'Start Date is required']"
                          outlined
                          dense
                          clearable
                          @change="getCheckMonthDifference"
                        />
                      </v-col>
                      <v-col>
                        <DatePicker
                          v-model="reportFilters.end_date"
                          type="date"
                          :allowed-dates="endDateValidation"
                          label="End date *"
                          :rules="[(val) => !!val || 'End Date is required']"
                          outlined
                          dense
                          clearable
                          @change="getCheckMonthDifference"
                        />
                      </v-col>
                      <v-col v-if="profileObject.role == 'account_admin'">
                        <SelectField
                          v-model="selectedBranch"
                          :itemsList="branchList"
                          type="date"
                          :label="`${configurationModule.branch}`"
                          itemText="name"
                          itemValue="id"
                          outlined
                          dense
                          :isClearable="false"
                          :multiple="true"
                        />
                      </v-col>
                      <v-col
                        v-if="
                          selectedReport.category == 'vehicle' &&
                          selectedReport.value != 'vehicleUTI'
                        "
                      >
                        <SelectField
                          v-model="selectedVehicle"
                          :itemsList="vehicleList"
                          type="date"
                          :label="`${fleetModule.vehicle}`"
                          itemText="vehicle_number"
                          itemValue="id"
                          :multiple="true"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                      <v-col v-if="selectedReport.category == 'driver'">
                        <SelectField
                          v-model="selectedDriver"
                          :itemsList="driverList"
                          type="date"
                          :label="`${fleetModule.driver}`"
                          itemText="full_name"
                          itemValue="id"
                          :multiple="true"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                      <v-col class="d-flex align-center justify-end">
                        <SecondaryButton
                          :disabled="!isValid"
                          @click="getReportData()"
                          name="Get Report"
                          btnClass="text-uppercase"
                        >
                        </SecondaryButton>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="6"
                        v-if="reportData && reportData.length > 0"
                      >
                        <span class="text-subtitle-1 font-weight-bold">{{
                          selectedReport.text
                        }}</span>
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="reportData && reportData.length > 0"
                        class="d-flex justify-end"
                      >
                        <v-tooltip left>
                          <template #activator="{ attrs, on }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              color="primary"
                              depressed
                              small
                              @click="getReportData(true)"
                            >
                              <v-icon>mdi-download</v-icon>
                            </v-btn>
                          </template>
                          <span>Export Report</span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="reportData && reportData.length > 0"
                      >
                        <AgGridVue
                          :style="`width: 100%; height: calc(100vh - ${
                            panel ? '600px' : '430px'
                          })`"
                          class="ag-theme-balham"
                          :columnDefs="reportHeaders"
                          :suppressDragLeaveHidesColumns="true"
                          :rowData="reportData"
                        ></AgGridVue>
                      </v-col>
                      <v-col
                        v-if="reportData && reportData.length > 0"
                        cols="12"
                        class="d-flex justify-end py-0"
                      >
                        <Pagination
                          :pageNo="pageNo"
                          :totalItems="totalItems"
                          :pageSize="itemsPerPage"
                          @itemsPerPageChange="itemsPerPageChanged"
                          @prevPage="prevPage()"
                          @nextPage="nextPage()"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { AgGridVue } from "ag-grid-vue";
import { downloadBlob, getDateTime } from "@/utils/functions";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import { returnToday } from "@/utils/functions";

import {
  reportsModule,
  fleetModule,
  orderModule,
  tripModule,
  configurationModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    AgGridVue,
    Pagination,
  },
  data() {
    return {
      returnToday,
      panel: true,
      rotatedIcon: "mdi-rotate-180",
      distinctErrors: [],

      reportsModule,
      fleetModule,
      orderModule,
      tripModule,
      configurationModule,
      // ag-grid conf

      selectedReport: {},
      reportFilters: {},

      isValid: false,

      driverList: [],
      vehicleList: [],
      branchList: [],

      itemsPerPage: 10,
      pageNo: 1,
      totalItems: 0,

      reportData: [],
      reportHeaders: [],

      currentTab: 0,

      selectedVehicle: null,
      selectedBranch: [],
      selectedDriver: null,

      reportTypes: [
        {
          text: "Operation Summary Report",
          value: "getOperationSummaryReportData",
          category: "order",
          type: "order",
          icon: "mdi-chart-areaspline",
        },
        {
          text: "Trips Report",
          value: "getTripReportData",
          category: "trip",
          type: "trip",
          icon: "mdi-truck-fast",
        },
        {
          text: "Order Report",
          value: "getOrderReportData",
          category: "order",
          type: "order",
          icon: "mdi-archive",
        },
        {
          text: "Driver Expense Report",
          value: "getDriverExpenseReportData",
          category: "driver",
          type: "expense",
          icon: "mdi-currency-usd",
        },
        {
          text: "Driver Attendance Report",
          value: "getDriverAttendanceReportData",
          category: "driver",
          type: "attendance",
          icon: "mdi-account-tie-hat",
        },
        {
          text: "Driver Trip Report",
          value: "getDriverTripReportData",
          category: "driver",
          type: "driver",
          icon: "mdi-account-tie-hat",
        },
        {
          text: "Driver Order Delivery Report",
          value: "getDriverOrderDeliveryReportData",
          category: "driver",
          type: "driver",
          icon: "mdi-account-tie-hat",
        },
        {
          text: "Vehicle Reports",
          value: "getVehicleReportData",
          category: "vehicle",
          type: "vehicle",
          icon: "mdi-truck-outline",
        },
        // {
        //   text: "Vehicle Km Reports",
        //   value: "getVehicleKilometerReportData",
        //   category: "vehicle",
        //   type: "vehiclekm",
        //   icon: "mdi-truck-trailer",
        // },
        {
          text: "Vehicle Odometer Reading Report",
          value: "getVehicleOdometerReportData",
          category: "vehicle",
          type: "vehiclemilage",
          icon: "mdi-truck-outline",
        },
        {
          text: "Vehicle Order Delivery Report",
          value: "getVehicleOrderDeliveryReportData",
          category: "vehicle",
          type: "vehicle",
          icon: "mdi-truck-outline",
        },
        {
          text: "Fleet Utilization",
          value: "getFleetUtilizationReportData",
          category: "vehicle",
          type: "fleetUtilization",
          icon: "mdi-truck-trailer",
        },
      ],

      dateKey: 0,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    userPrefferedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
  },
  methods: {
    startDateValidation(date) {
      let today = new Date();
      const yesterday = new Date(today);

      yesterday.setDate(yesterday.getDate() - 1);

      if (!this.reportFilters.end_date) {
        return yesterday.getTime() > new Date(date).getTime();
      } else {
        let dateToCompare = new Date(this.reportFilters.end_date);
        return dateToCompare.getTime() > new Date(date).getTime();
      }
    },
    endDateValidation(date) {
      let today = new Date();
      const yesterday = new Date(today);

      yesterday.setDate(yesterday.getDate() - 1);
      if (!this.reportFilters.start_date) {
        return yesterday.getTime() > new Date(date).getTime();
      } else {
        let dateToCompare = new Date(this.reportFilters.start_date);
        return (
          dateToCompare.getTime() < new Date(date).getTime() &&
          yesterday.getTime() > new Date(date).getTime()
        );
      }
    },
    getTableHeaderData(data) {
      return Object.keys(data).map((key) => {
        return {
          headerName: key.replace(/_/g, "  "),
          field: key,
          sortable: false,
          cellClass: "text-capitalize",
        };
      });
    },
    getDriverList() {
      this.reportFilters.driver = [];

      let params = {
        limit: "all",
      };

      this.$api.driver
        .getDriverList(params)
        .then((res) => {
          this.driverList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getVehicleList(params = {}) {
      this.reportFilters.vehicle = [];
      params = {
        ...params,
        limit: "all",
      };
      this.$api.vehicle
        .getVehicleList(params)
        .then((res) => {
          this.vehicleList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCheckMonthDifference() {
      if (
        this.reportFilters &&
        this.reportFilters.start_date &&
        this.reportFilters.end_date
      ) {
        const date1 = new Date(this.reportFilters.start_date);
        const date2 = new Date(this.reportFilters.end_date);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 30) {
          bus.$emit("showToastMessage", {
            message: "A maximum of 30 days worth of data can be retrieved",
            color: "error",
          });
          this.reportFilters.start_date = null;
          this.reportFilters.end_date = null;
        }
      }
      this.dateKey++;
    },
    getBranchList() {
      this.branchList = [];
      this.$api.branch
        .getBranchSelectList({ limit: "all" })
        .then((res) => {
          this.branchList = res.data;
          if (
            this.profileObject.role != "account_admin" &&
            this.userPrefferedBranch
          ) {
            this.selectedBranch = this.userPrefferedBranch;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getReportData(download = false) {
      let params = {
        ...this.reportFilters,
      };
      if (!download) {
        params = {
          ...params,
          limit: this.itemsPerPage,
          offset: this.offset,
        };
      } else {
        params = {
          ...params,
          limit: "all",
        };
      }
      if (this.selectedReport.category == "driver" && this.selectedDriver) {
        params = {
          ...params,
          driver:
            this.selectedDriver.length > 0 ? this.selectedDriver.join(",") : "",
        };
      }
      if (this.selectedReport.category == "vehicle" && this.selectedVehicle) {
        params = {
          ...params,
          vehicle:
            this.selectedVehicle.length > 0
              ? this.selectedVehicle.join(",")
              : "",
        };
      }
      if (this.profileObject.role == "account_admin") {
        params = {
          ...params,
          branch:
            this.selectedBranch.length > 0 ? this.selectedBranch.join(",") : "",
        };
      } else {
        params = {
          ...params,
          branch: this.selectedBranch,
        };
      }
      this.$api.reports[this.selectedReport.value](
        params,
        download ? { Accept: "application/xlsx" } : {}
      )
        .then((res) => {
          if (!download) {
            if (res.data && res.data.length > 0) {
              this.reportHeaders = this.getTableHeaderData(res.data[0]);
              this.reportData = res.data;
              this.totalItems = res.count;
            } else {
              bus.$emit("showToastMessage", {
                message: "No Data Found!",
                color: "error",
              });
              this.reportHeaders = [];
              this.reportData = [];
            }
          } else {
            downloadBlob(
              new Blob([res.data]),
              `${this.reportFilters.start_date}-${this.reportFilters.end_date} ${this.selectedReport.text}`,
              ".xlsx"
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;

      this.getReportData();
    },
    prevPage() {
      this.pageNo--;
      this.getReportData();
    },
    nextPage() {
      this.pageNo++;
      this.getReportData();
    },
    updateReportType(reportTypes) {
      this.selectedReport = reportTypes;
      this.reportData = [];
      this.reportHeaders = [];
      // this.reportFilters = {};
      this.selectedDriver = null;
      this.selectedVehicle = null;
      if (this.profileObject.role == "account_admin") {
        this.selectedBranch = [];
      }
    },
  },
  mounted() {
    this.reportFilters = {
      start_date: returnToday(-15),
      end_date: returnToday(0),
    };
    this.getDriverList();
    this.getVehicleList();
    this.getBranchList();
    this.updateReportType(this.reportTypes[0]);
    setTimeout(() => {
      this.getReportData();
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
.card-height {
  height: 120px;
}
.on-hover {
  &:hover {
    box-shadow: 2px 2px 10px -5px rgb(0 0 0 / 20%);
  }
}
.report-grid {
  display: grid;
  grid-template-columns: repeat(6, 285px);
  overflow-y: auto;
}
@media screen and (max-width: 1600px) {
  .report-grid {
    grid-template-columns: repeat(6, 200px);
  }
}
@media screen and (max-width: 1400px) {
  .report-grid {
    grid-template-columns: repeat(6, 200px);
  }
}
</style>
